import {isOdd} from './isOdd';
export {isOdd};
